/* eslint-disable */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import FormField from '../formField';
import Accessory from './Accessories';
import Features from './Features';
import Promotions from './Promotions';
import { FormFieldsWrapper, GroupTitle, GroupWrapper } from '../css';
import { Modal } from '@telus-uds/components-web';
import request from '../../utils/request';
import { isRelatedFieldExisted } from '../formStepWLSUtils';
import { getFieldChecked, getFieldValue } from '../utils';
import { useTranslationsContext } from '../../context/TranslationsContext';
import {
  getValueTier as getThreeYearValueTier,
  isDevicesFieldVisible as isDevicesFieldThreeYearsVisible,
  threeYearFieldsToClear
} from './ThreeYearWLS/ThreeYearWLS';
import WlsLoader from '../../design/shared/WlsLoader';
import {
  fieldSubscriberDetailsContractTerm,
  fieldSubscriberDetailsDevicePlan,
  fieldSubscriberDetailsTier,
  fieldSubscriberDetailsDevices,
  fieldSubscriberDetailsColor,
  fieldSubscriberDetailsHardwareCredit,
  fieldSubscriberDetailsIsCpoDevice,
  fieldSubscriberDetailsCpoCategory,
  fieldSubscriberDetailsEsimSubmission,
  fieldSubscriberDetailsRateplanName,
  fieldSubscriberDetailsRateplanCost,
  fieldSubscriberDetailsDeviceBalanceWaive,
  fieldSubscriberDetailsDeviceBalanceWaiveValue,
  fieldSubscriberDetailsDeviceBalanceWaiveRemainingBalance,
  fieldSubscriberDetailsBibProgram,
  fieldSubscriberDetailsBibCredit,
  fieldSubscriberDetailsDeviceCredit,
  fieldSubscriberDetailsSpecialInstructions,
  fieldSubscriberDetailsExistingPhoneNumber,
  fieldSubscriberDetailsDeviceEnrolmentProgram,
  subscriberDetailsPhoneNumberRenewal,
  renewal,
  newWirelessActivation,
  addOnActivation,
  subscriberDetailsWillPhoneNumberBePortedIn,
  subscriberDetailsContractTerm,
  DevicesOnlyEnglish,
  DevicesOnlyFrench,
  devicePlanCategorySmartphones,
  contractTerm2Year,
  contractTerm2YearFr,
  AccessoriesOnlyEnglish,
  AccessoriesOnlyFrench,
  contractTerm3Year,
  fieldBusinessRegularMedium,
  subscriberDetailsDeviceEnrolmentProgram,
  contractTermBYOD,
  subscriberDetailsIsSimRequired,
  subscriberDetailsIsSimRequiredDevicesAccessories,
  fieldSubscriberDetailsTypeOfDevice,
  fieldSubscriberDetailsThreeYearTier,
  fieldSubscriberDetailsThreeYearHardwareCredits,
  subscriberDetailsFirstName,
  subscriberDetailsLastName,
  subscriberDetailsPhoneNumber,
  subscriberDetailsServiceProvider,
  subscriberDetailsAccountNumber,
  subscriberDetailsPortInCredit,
  subscriberDetailsLocalCity,
  fieldSubscriberDetailsValidationCode,
  subscriberDetailsAccessoryFinanced,
  SmbOnlineEnglish,
  SmbOnlineFrench,
  sevenX,
  fieldsimType2Year,
  fieldsimTypeByod,
  fieldDeviceType,
  fieldEid,
  fieldImei,
  valueEsim,
  fieldSubscriberDetailsPromotions,
  smbOnlineOrder,
  orderIsNotEligibleForMSSFrenchMappings,
  fieldSubscriberExtendedWarrantyProgram,
  fieldSubscriberDetailsDeviceCare,
  appleCareTier5,
  appleCareTier4,
  appleCarePlus12,
  appleCarePlus9,
  appleCareTier4A,
  fieldEidTablet,
  fieldImeiTablet,
  fieldDeviceTypeTablet,
  fieldsimTypeTablet,
  fieldsimType3Year,
  appleIphoneSixteenDevicesWLS,
  subscriberExtendedWarrantyProgramBYOD,
  subscriberDetailsDeviceCareBYOD,
  subscriberTierStandardZeroUpfront
} from '../../utils/constant';
import { isJson } from '../../utils/utils';
import {
  getCategories,
  getDevices,
  getColorOptions,
  resetFeidValue,
  calculateTotal,
  getTierCode
} from './utils';
import EN from '../../../EN.json';
import FR from '../../../FR.json';
import { useLocaleContext } from '../../context/LocaleContext';

const profile = request.getProfile();
const Form = ({
  formStepFields,
  formFields,
  setFormFields,
  orderData,
  onFormSubmit,
  setFormTouched,
  formTouched,
  formErrors,
  setFormErrors,
  selectedFeatures,
  setSelectedFeatures,
  selectedDeviceCare,
  setSelectedDeviceCare,
  selectedAccessories,
  setSelectedAccessories,
  selectedPromotions,
  setSelectedPromotions,
  // totalSubscribers,
  setTotal,
  total,
  subscriberDetails,
  editingSubscriber,
  setEditingSubscriberNumber,
  isCopyFromSubscriber,
  setIsCopyFromSubscriber,
  copyFromSubscriber,
  selectedDeviceCareBYOD,
  setSelectedDeviceCareBYOD
}) => {
  const channelWLS = profile.channel === undefined ? '' : profile.channel;
  const isChannelSevenX = channelWLS && channelWLS.name === sevenX;
  const translations = useTranslationsContext();
  const locale = useLocaleContext();
  const {
    contentfulValues: {
      no,
      yes,
      wirelessOrderDetails: {
        valueBYOD,
        valueVoiceOnly,
        valueUnlimitedForBusiness,
        valueTwoYear,
        valueOwnersAdvantagePlan,
        valueDevicePurchaseMtm,
        valueByod,
        valueDeviceCare,
        deviceCreditErrorMessage,
        sectionSpecialOffers
      }
    },
    formButtons: { acknowledgeVerbiage, acknowledgeButton }
  } = translations;

  const {
    contentfulValues: {
      wirelessOrderDetails: {
        valueThreeYear,
        valueTablet,
        valueWatch,
        valueMobileHighSpeedSmartHub,
        valueBasicEasyPayment,
        valueBusinessSharePro,
        valueEasyPayment,
        valueSmartphone
      }
    }
  } = locale === 'en-US' ? EN : FR;

  const {
    contentfulValues: {
      wirelessOrderDetails: {
        valueThreeYear: valueThreeYearEnglish,
        valueDeviceCare: valueDeviceCareEnglish,
        sectionSpecialOffers: sectionSpecialOffersEnglish,
        simRequiredReasonOnly: simRequiredReasonOnlyEnglish
      }
    }
  } = EN;

  const {
    contentfulValues: {
      wirelessOrderDetails: {
        valueThreeYear: valueThreeYearFrench,
        valueDeviceCare: valueDeviceCareFrench,
        sectionSpecialOffers: sectionSpecialOffersFrench,
        simRequiredReasonOnly: simRequiredReasonOnlyFrench
      }
    }
  } = FR;

  const valueThreeYearVariations = [
    valueThreeYearEnglish,
    valueThreeYearFrench
  ];
  // Removing Device care completely sof-2354
  // const valueDeviceCareVariation = [
  //   valueDeviceCareEnglish,
  //   valueDeviceCareFrench
  // ];
  const sectionSpecialOffersVariations = [
    sectionSpecialOffersEnglish,
    sectionSpecialOffersFrench
  ];
  const simRequiredReasonOnlyVariations = [
    simRequiredReasonOnlyEnglish,
    simRequiredReasonOnlyFrench
  ];

  const [isLoading, setIsLoading] = useState({
    status: false,
    message: ''
  });
  const [deviceCreditError, setDeviceCreditError] = useState('');
  const [additionalFeaturesVisible, setAdditionalFeaturesVisible] = useState(
    true
  );
  const [showOnlyCategories, setShowOnlyCategories] = useState([]);
  const [isAccessoriesOnly, setIsAccessoriesOnly] = useState(false);
  const [isDevicesOnly, setIsDevicesOnly] = useState(false);
  const [copyDeviceCareOptions, setCopyDeviceCareOptions] = useState(
    formFields[fieldSubscriberDetailsDeviceCare] &&
      formFields[fieldSubscriberDetailsDeviceCare].options
  );

  const [modalData, setModalData] = useState({
    title: '',
    body: '',
    open: false
  });
  const isSMBOnline =
    formStepFields &&
    orderData.orderNotEligibleforMssReason &&
    (orderData.orderNotEligibleforMssReason.includes(SmbOnlineEnglish) ||
      orderData.orderNotEligibleforMssReason.includes(SmbOnlineFrench));

  const getUpdatedOptions = (options, valuesToFilter) => {
    return options.filter(
      option => !valuesToFilter.includes(option.fields.value)
    );
  };

  // Saving Device Care selections for pricing

  useEffect(() => {
    if (
      formFields &&
      formFields[fieldSubscriberDetailsDeviceCare] &&
      formFields[fieldSubscriberDetailsDeviceCare].value &&
      formFields[fieldSubscriberDetailsDeviceCare].options
    ) {
      const deviceCareSelections =
        formFields[fieldSubscriberDetailsDeviceCare].value;
      const deviceCareOptions =
        formFields[fieldSubscriberDetailsDeviceCare].options;
      const result = deviceCareOptions
        .filter(obj => deviceCareSelections.includes(obj.fields.value))
        .map(({ fields }) => ({
          name: fields.label,
          price: fields.price,
          value: fields.value
        }));
      setSelectedDeviceCare(result);
    }
  }, [
    formFields[fieldSubscriberDetailsDeviceCare] &&
      formFields[fieldSubscriberDetailsDeviceCare].value
  ]);

  useEffect(() => {
    if (
      formFields &&
      formFields[subscriberDetailsDeviceCareBYOD] &&
      formFields[subscriberDetailsDeviceCareBYOD].value &&
      formFields[subscriberDetailsDeviceCareBYOD].options
    ) {
      const deviceCareSelections =
        formFields[subscriberDetailsDeviceCareBYOD].value;
      const deviceCareOptions =
        formFields[subscriberDetailsDeviceCareBYOD].options;
      const result = deviceCareOptions
        .filter(obj => deviceCareSelections.includes(obj.fields.value))
        .map(({ fields }) => ({
          name: fields.label,
          price: fields.price,
          value: fields.value
        }));
      setSelectedDeviceCare(result);
    }
  }, [
    formFields[subscriberDetailsDeviceCareBYOD] &&
      formFields[subscriberDetailsDeviceCareBYOD].value
  ]);

  useEffect(() => {
    if (!copyDeviceCareOptions) {
      setCopyDeviceCareOptions(
        formFields[fieldSubscriberDetailsDeviceCare] &&
          formFields[fieldSubscriberDetailsDeviceCare].options
      );
    }
  }, [formFields]);

  const noneConditionDevices = (devices = []) => {
    return [...devices].filter(e => {
      const device = e['fields']['label'].trim().toLocaleLowerCase();
      return !(
        device.includes('activations') ||
        device.includes('activation') ||
        device.includes('renewals') ||
        device.includes('renewal')
      );
    });
  };

  const conditionalDevices = (devices = [], condition = '') => {
    condition = condition.trim().toLowerCase() || '';
    const type =
      condition &&
      (condition === 'New Wireless Activation'.trim().toLowerCase() ||
        condition ===
          'Nouvelle commande de services sans fil'.trim().toLowerCase() ||
        condition === 'Ajout à un compte existant'.trim().toLowerCase() ||
        condition === 'Add-on Activation'.trim().toLowerCase())
        ? ['activations', 'activation']
        : ['renewals', 'renewal'];
    return [...devices].filter(e => {
      const device = e['fields']['label'].trim().toLocaleLowerCase();
      return device.includes(type[0]) || device.includes(type[1]);
    });
  };

  const getDevicesFromAPI = async (
    vCategory,
    vIsCOP,
    vTier,
    vProvince,
    vCpoCategory,
    vContractTerm,
    vIsBIB,
    isDevicesOnly = false,
    vHardwareCredit
  ) => {
    const devices = await getDevices({
      vCategory,
      vIsCOP,
      vTier,
      vProvince,
      vCpoCategory,
      vContractTerm,
      vIsBIB,
      vHardwareCredit
    });
    if (devices) {
      if (isDevicesOnly) return devices;
      const { installationTypeWLS = '' } = orderData;
      return [
        ...conditionalDevices(devices, installationTypeWLS),
        ...noneConditionDevices(devices)
      ];
    }
    return [];
  };
  const valueExtendedWarrantyProgram = getFieldValue(
    fieldSubscriberExtendedWarrantyProgram,
    formFields
  );
  const valueExtendedWarrantyProgramBYOD = getFieldValue(
    subscriberExtendedWarrantyProgramBYOD,
    formFields
  );
  useEffect(() => {
    // Check the condition when the component mounts or when formFields changes
    if (
      formFields &&
      formFields[fieldSubscriberExtendedWarrantyProgram] &&
      (formFields[fieldSubscriberExtendedWarrantyProgram].value === 'No' ||
        formFields[fieldSubscriberExtendedWarrantyProgram].value === 'Non' ||
        formFields[subscriberExtendedWarrantyProgramBYOD].value === no)
    ) {
      setModalData({ open: true, text: acknowledgeVerbiage });
    }
  }, [valueExtendedWarrantyProgram, valueExtendedWarrantyProgramBYOD]);
  const onFieldChange = async (
    { name, value, checked },
    refV,
    isTouched,
    parentRequiredObject
  ) => {
    setFormTouched(true);
    let fields = { ...formFields };
    fields[name].value = value;
    fields[name].isTouched = isTouched;
    if (fields[name].type === 'Checkbox') {
      fields[name].checked = checked;
      fields[name].value = checked;
    }
    /**
     * Field Resetting when Device Plan is seleced
     */
    if (
      [
        fieldSubscriberDetailsContractTerm,
        fieldSubscriberDetailsDevicePlan
      ].includes(name)
    ) {
      const updatedFields = resetFeidValue(fields, [
        fieldSubscriberDetailsTier,
        fieldSubscriberDetailsDevices,
        fieldSubscriberDetailsColor,
        fieldSubscriberDetailsHardwareCredit,
        fieldSubscriberDetailsIsCpoDevice,
        fieldSubscriberDetailsCpoCategory,
        fieldSubscriberDetailsEsimSubmission,
        fieldSubscriberDetailsRateplanName,
        fieldSubscriberDetailsRateplanCost,
        fieldSubscriberDetailsDeviceBalanceWaive,
        fieldSubscriberDetailsDeviceBalanceWaiveValue,
        fieldSubscriberDetailsDeviceBalanceWaiveRemainingBalance,
        fieldSubscriberDetailsBibProgram,
        fieldSubscriberDetailsBibCredit,
        fieldSubscriberDetailsDeviceCredit,
        fieldsimType2Year,
        fieldsimTypeByod,
        fieldDeviceType,
        fieldEid,
        fieldImei,
        fieldEidTablet,
        fieldImeiTablet,
        fieldDeviceTypeTablet,
        fieldsimTypeTablet
      ]);

      fields = { ...fields, ...updatedFields };
    }

    if (name === fieldSubscriberDetailsContractTerm && value !== valueBYOD) {
      formFields[
        subscriberExtendedWarrantyProgramBYOD
      ].value = undefined;
      formFields[subscriberDetailsDeviceCareBYOD].value = [];
    }

    if(name === subscriberExtendedWarrantyProgramBYOD && value === no){
      formFields[subscriberDetailsDeviceCareBYOD].value = [];
    }

    if (
      name === fieldSubscriberDetailsContractTerm &&
      value === valueBYOD
    ) {
      formFields[fieldSubscriberDetailsDeviceCare].value = [];
      formFields[fieldSubscriberDetailsDeviceCare].isRequired = false;
    }

    if (
      name === fieldSubscriberDetailsIsCpoDevice ||
      (name === fieldSubscriberExtendedWarrantyProgram && formFields)
    ) {
      if (
        formFields &&
        formFields[fieldSubscriberDetailsIsCpoDevice].value &&
        formFields[fieldSubscriberExtendedWarrantyProgram].value &&
        formFields[fieldSubscriberDetailsDeviceCare].value !== undefined
      ) {
        formFields[fieldSubscriberDetailsDeviceCare].value = [];
      }
    }

    // Reset device field value on changing tier
    if (name === fieldSubscriberDetailsTier) {
      fields[fieldSubscriberDetailsDevices].value = '';
    }
    // Remove three year selection when unselecting three year contract term
    if (
      name === subscriberDetailsContractTerm &&
      getFieldValue(subscriberDetailsContractTerm, formFields) !==
        valueThreeYear
    ) {
      threeYearFieldsToClear.forEach(field => {
        formFields[field].value = '';
      });
    }
    if (name === fieldsimTypeByod) {
      const updatedFields = resetFeidValue(fields, [
        fieldEid,
        fieldImei,
        fieldSubscriberDetailsEsimSubmission
      ]);
      fields = { ...fields, ...updatedFields };
    }
    if (name === fieldDeviceType) {
      const updatedFields = resetFeidValue(fields, [
        fieldsimTypeByod,
        fieldEid,
        fieldImei
      ]);
      fields = { ...fields, ...updatedFields };
    }
    if (name === fieldsimTypeTablet) {
      const updatedFields = resetFeidValue(fields, [
        fieldEidTablet,
        fieldImeiTablet
      ]);
      fields = { ...fields, ...updatedFields };
    }
    if (name === fieldDeviceTypeTablet) {
      const updatedFields = resetFeidValue(fields, [
        fieldsimTypeTablet,
        fieldEidTablet,
        fieldImeiTablet
      ]);
      fields = { ...fields, ...updatedFields };
    }
    if (name === subscriberDetailsWillPhoneNumberBePortedIn) {
      const updatedFields = resetFeidValue(fields, [
        subscriberDetailsLocalCity,
        subscriberDetailsPhoneNumber,
        subscriberDetailsServiceProvider,
        subscriberDetailsAccountNumber,
        subscriberDetailsPortInCredit
      ]);
      fields = { ...fields, ...updatedFields };
    }

    // Reset device condition fields when tradeInImei is empty
    if (name === 'tradeInImei') {
      const fieldsToReset = [
        'devicePowerOn',
        'deviceActivationLock',
        'devicePhysicalCondition',
        'deviceDisplayIssues',
        'deviceComponentsFunctionality'
      ];
      
      if (!value || value.trim() === '') {
        // Reset dependent fields when tradeInImei is empty
        fieldsToReset.forEach(fieldName => {
          if (fields[fieldName]) {
            fields[fieldName].value = '';
            fields[fieldName].checked = false; // Reset checkbox fields
            fields[fieldName].isVisible = false;
            fields[fieldName].isRequired = false;
          }
        });
        }
      }
      
    // Handle customerTradeIn visibility based on devicePlanCategory
    if (name === fieldSubscriberDetailsDevicePlan) {
      const allowedCategories = ['Smartphone', 'Smartphones', 'BYOD Smartphone'];
      const isSmartphoneCategory = value && allowedCategories.includes(value);
      
      if (fields.customerTradeIn) {
        if (!isSmartphoneCategory) {
          fields.customerTradeIn.value = '';
          fields.tradeInDeviceName.value = '';
          fields.tradeInImei.value = '';
          
          // Clear customerTradeIn value for current subscriber only
          if (orderData.subscriberDetails && Array.isArray(orderData.subscriberDetails) && editingSubscriber) {
            orderData.subscriberDetails = orderData.subscriberDetails.map(subscriber => {
              if (subscriber.id === editingSubscriber) {
                return {
                  ...subscriber,
                  customerTradeIn: '',
                  tradeInImei: '',
                  tradeInDeviceName: ''
                };
              }
              return subscriber;
            });
          } else if (orderData.customerTradeIn !== undefined) {
            orderData.customerTradeIn = '';
          }
        }
      }
    }
     if(name === 'customerTradeIn')
    {
        if(['no','non'].includes(value.toLocaleLowerCase()))
        {
            fields.tradeInDeviceName.value = '';
            fields.tradeInImei.value = '';
            
            // Clear device condition fields in formFields
            const deviceConditionFields = [
              'deviceActivationLock',
              'deviceComponentsFunctionality', 
              'deviceDisplayIssues',
              'devicePhysicalCondition',
              'devicePowerOn'
            ];
            
            deviceConditionFields.forEach(fieldName => {
              if (fields[fieldName]) {
                fields[fieldName].value = '';
                fields[fieldName].checked = false;
                fields[fieldName].isVisible = false;
                fields[fieldName].isRequired = false;
              }
            });
            
            // Clear device condition fields in orderData for current subscriber only
            if (orderData.subscriberDetails && Array.isArray(orderData.subscriberDetails) && editingSubscriber) {
              orderData.subscriberDetails = orderData.subscriberDetails.map(subscriber => {
                if (subscriber.id === editingSubscriber) {
                  return {
                    ...subscriber,
                    deviceActivationLock: '',
                    deviceComponentsFunctionality: '',
                    deviceDisplayIssues: '',
                    devicePhysicalCondition: '',
                    devicePowerOn: ''
                  };
                }
                return subscriber;
              });
            }
        }
    }
    if (
      name === fieldSubscriberDetailsDevicePlan &&
      getFieldValue(fieldSubscriberDetailsDevicePlan, formFields) !==
        valueBusinessSharePro &&
      getFieldValue(fieldSubscriberDetailsDevicePlan, formFields) !==
        valueEasyPayment
    ) {
      threeYearFieldsToClear.slice(1).forEach(field => {
        formFields[field].value = '';
      });
    }
    if (
      name === fieldSubscriberDetailsTypeOfDevice &&
      getFieldValue(fieldSubscriberDetailsTypeOfDevice, formFields) !==
        valueSmartphone
    ) {
      threeYearFieldsToClear.slice(2).forEach(field => {
        formFields[field].value = '';
      });
    }

    /**
     * Conditions on fetching devices from BE for different Device Plans
     *
     * */

    if (
      [
        fieldSubscriberDetailsDevicePlan,
        fieldSubscriberDetailsTier,
        fieldSubscriberDetailsIsCpoDevice,
        fieldSubscriberDetailsCpoCategory,
        subscriberDetailsContractTerm,
        fieldSubscriberDetailsBibProgram,
        fieldSubscriberDetailsTypeOfDevice,
        fieldSubscriberDetailsThreeYearTier,
        fieldSubscriberDetailsThreeYearHardwareCredits
      ].includes(name)
    ) {
      let valueCategory = '';
      if (value === valueDevicePurchaseMtm) {
        fields[
          fieldSubscriberDetailsDevicePlan
        ].value = valueMobileHighSpeedSmartHub;
        valueCategory = valueMobileHighSpeedSmartHub;
      } else if (value === valueBasicEasyPayment) {
        valueCategory = valueVoiceOnly;
      } else if (value === valueVoiceOnly) {
        valueCategory = valueVoiceOnly;
      } else if (
        getFieldValue(
          fieldSubscriberDetailsThreeYearHardwareCredits,
          formFields
        )
      ) {
        valueCategory = getFieldValue(
          fieldSubscriberDetailsTypeOfDevice,
          formFields
        );
      } else {
        valueCategory = getFieldValue(
          fieldSubscriberDetailsDevicePlan,
          formFields
        );
      }
      const valueIsCpoDevice = getFieldValue(
        fieldSubscriberDetailsIsCpoDevice,
        formFields
      );

      const valueContractTerm = getFieldValue(
        subscriberDetailsContractTerm,
        formFields
      );
      const valueCpoCategory = getFieldValue(
        fieldSubscriberDetailsCpoCategory,
        formFields
      );
      const valueSelectedThreeYearTier = getFieldValue(
        fieldSubscriberDetailsThreeYearTier,
        formFields
      );
      const valueHardwareCredit = getFieldValue(
        fieldSubscriberDetailsThreeYearHardwareCredits,
        formFields
      );
      const {
        tier: valueTierThreeYear,
        hardwareCredit
      } = getThreeYearValueTier(
        valueSelectedThreeYearTier,
        valueHardwareCredit
      );
      let valueTier = '';
      if (getFieldValue(fieldSubscriberDetailsTier, formFields)) {
        valueTier = getFieldValue(fieldSubscriberDetailsTier, formFields);
      } else {
        valueTier = valueTierThreeYear;
      }
      const valueProvince = localStorage.getItem('provinceWLS')
        ? localStorage.getItem('provinceWLS')
        : '';

      const valueBIB = getFieldValue(
        fieldSubscriberDetailsBibProgram,
        formFields
      );
      if (
        [
          valueVoiceOnly,
          valueTablet,
          valueWatch,
          valueMobileHighSpeedSmartHub,
          valueBasicEasyPayment
        ].includes(valueCategory) ||
        (valueCategory === valueUnlimitedForBusiness &&
          (valueIsCpoDevice === no || valueCpoCategory)) ||
        (valueContractTerm === valueOwnersAdvantagePlan && valueTier) ||
        (valueTierThreeYear && valueHardwareCredit)
      ) {
        if (refV) {
          fields[fieldSubscriberDetailsDevices].options = [];
          fields[fieldSubscriberDetailsDevices].value = undefined;
        }
        setDeviceCreditError('');
        setIsLoading({ status: true, message: 'Fetching devices...' });
        const vIsCOP = valueIsCpoDevice === yes;
        const vIsBIB = valueBIB === yes;
        const devices = await getDevicesFromAPI(
          valueCategory,
          vIsCOP,
          valueTier,
          valueProvince,
          valueCpoCategory,
          valueContractTerm,
          vIsBIB,
          false,
          hardwareCredit
        );
        if (devices && devices.length) {
          fields[fieldSubscriberDetailsDevices].options = devices;
        }
        // Always clear loading, even when the fetch returns an empty/undefined result —
        // same fix as the Devices-Only prefetch effect above, same "stuck spinner" bug class.
        setIsLoading({ status: false, message: '' });
      }
    }

    /**
     * Setting the device Color, Hardware Credit and BIB options
     */
    if (name === fieldSubscriberDetailsDevices && value) {
      const valueDevice = isJson(value) ? JSON.parse(value) : value;
      const valueColor =
        valueDevice && valueDevice.colours
          ? valueDevice.colours
          : valueDevice.color && valueDevice.color;
      const valueTierCode = getTierCode(fields);
      const valueHardwareCredit = +_.get(
        valueDevice,
        `${valueTierCode}_Hardware_credit`,
        0
      );
      const valueBibCredit = +_.get(valueDevice, 'bibamount', 0);

      if (valueColor) {
        fields[fieldSubscriberDetailsColor].options = getColorOptions(
          valueColor
        );
      } else fields[fieldSubscriberDetailsColor].options = [];
      if (fields[fieldSubscriberDetailsHardwareCredit]) {
        if (valueHardwareCredit) {
          fields[
            fieldSubscriberDetailsHardwareCredit
          ].value = valueHardwareCredit;
          fields[fieldSubscriberDetailsHardwareCredit].isDisabled = true;
        } else {
          fields[fieldSubscriberDetailsHardwareCredit].value = '';
          fields[fieldSubscriberDetailsHardwareCredit].isDisabled = false;
        }
      }

      if (fields[fieldSubscriberDetailsBibCredit]) {
        if (valueBibCredit) {
          fields[fieldSubscriberDetailsBibCredit].value = valueBibCredit;
          fields[fieldSubscriberDetailsBibCredit].isDisabled = true;
        } else {
          fields[fieldSubscriberDetailsBibCredit].value = '';
          fields[fieldSubscriberDetailsBibCredit].isDisabled = false;
        }
      }
    }
    /**
     * Condition for Owner's Advantage Plan
     */
    if (fieldSubscriberDetailsContractTerm) {
      if (value === valueOwnersAdvantagePlan) {
        fields[
          fieldSubscriberDetailsDevicePlan
        ].value = valueUnlimitedForBusiness;
        fields[
          fieldSubscriberDetailsRateplanName
        ].value = valueOwnersAdvantagePlan;
        fields[fieldSubscriberDetailsRateplanName].isDisabled = true;
        fields[fieldSubscriberDetailsRateplanCost].value = 100;
        fields[fieldSubscriberDetailsRateplanCost].isDisabled = true;
      } else {
        fields[fieldSubscriberDetailsRateplanName].isDisabled = false;
        fields[fieldSubscriberDetailsRateplanCost].isDisabled = false;
      }
      if (
        ![valueOwnersAdvantagePlan, valueDevicePurchaseMtm].includes(value) &&
        name === fieldSubscriberDetailsContractTerm
      ) {
        fields[fieldSubscriberDetailsDevicePlan].value = '';
      }
    }

    /**
     * Checking if Device Credit can be applied
     */
    if (name === fieldSubscriberDetailsDeviceCredit && value) {
      setDeviceCreditError('');
      const valueCategory = getFieldValue(
        fieldSubscriberDetailsDevicePlan,
        formFields
      );
      if (isTouched) {
        if (valueCategory === valueUnlimitedForBusiness) {
          let sum = 0;
          total.summary.dueNowList.forEach(item => {
            if (item.name !== 'Device Credit') {
              if (item.upfrontValue && item.type === 'ADD') {
                sum += +item.upfrontValue;
              }
            }
          });
          if (sum < +value) {
            setDeviceCreditError(deviceCreditErrorMessage);
            fields[name].value = '';
          }
        } else {
          let sum = 0;
          total.summary.dueNowList.forEach(item => {
            if (item.name !== 'Device Credit') {
              if (item.upfrontValue && item.type === 'ADD') {
                sum += +item.price;
              }
            }
          });
          if (sum < +value) {
            fields[name].value = '';
          }
        }
      }
    }
    calculateTotal(
      translations,
      fields,
      subscriberDetails,
      parentRequiredObject.childAccessories,
      parentRequiredObject.childFeatures,
      parentRequiredObject.childDeviceCare,
      setTotal,
      editingSubscriber,
      orderData,
      parentRequiredObject.childDeviceCareBYOD,
    );
    setFormFields({ ...fields });
  };

  const renderFormFields = data =>
    data &&
    data.length > 0 &&
    data.map(({ sys, fields }, indexRoot) => {
      const {
        contentType: {
          sys: { id }
        },
        id: sysId
      } = sys;
      const { name: fieldName, title } = fields;
      let selectOptions;
      const error = formErrors[fieldName];
      const key = `FormField${fieldName}${indexRoot}${sysId}`;
      let result;
      const removedAppearsAfterFunctionalityFieldsDevicesOnly = [
        fieldSubscriberDetailsColor,
        fieldSubscriberDetailsDevices
      ];
      const clearFieldErrors = fieldName => {
        const updatedErrors = formErrors;
        delete updatedErrors[fieldName];
        setFormErrors(updatedErrors);
      };
      if (
        orderData.orderNotEligibleforMssReason &&
        isDevicesOnly &&
        removedAppearsAfterFunctionalityFieldsDevicesOnly.includes(fieldName)
      ) {
        fields.appearsAfterValue = undefined;
        fields.appearsAfterField = undefined;
      }

      if (!isRelatedFieldExisted(fields, formFields, orderData, formTouched))
        return null;
      const fieldValue = getFieldValue(fieldName, formFields);
      const fieldChecked = getFieldChecked(fieldName, formFields);
      /*
       * Check to display subscriberDetailsPhoneNumberRenewal only for Renewal
       */
      if (
        fieldName === subscriberDetailsPhoneNumberRenewal &&
        !renewal.includes(orderData.installationTypeWLS) &&
        formFields.subscriberDetailsPhoneNumberRenewal
      ) {
        formFields.subscriberDetailsPhoneNumberRenewal.isVisible = false;
        return null;
      }

      // Hide Extended Warranty question if cpo is not selected
      if (
        fieldName === fieldSubscriberExtendedWarrantyProgram &&
        formFields &&
        ((formFields[subscriberDetailsContractTerm].value === '2 Year' &&
          !formFields[fieldSubscriberDetailsIsCpoDevice].value) ||
          formFields[subscriberDetailsContractTerm].value === 'BYOD')
      ) {
        formFields[fieldSubscriberExtendedWarrantyProgram].isVisible = false;
        formFields[fieldSubscriberExtendedWarrantyProgram].value = '';
        orderData[fieldSubscriberExtendedWarrantyProgram] = '';
        return null;
      }

      // Hide Extended Warranty question for Add-on Activation in QC province
      if (
        (fieldSubscriberExtendedWarrantyProgram, subscriberExtendedWarrantyProgramBYOD).includes(fieldName) &&
        formFields &&
        orderData &&
        orderData.installationTypeWLS &&
        addOnActivation.includes(orderData.installationTypeWLS)
      ) {
        // Check multiple province sources for QC
        const isQCProvince = 
          (orderData.provinceWLS && (orderData.provinceWLS === 'quebec')
        );
        
        if (isQCProvince) {
          formFields[subscriberExtendedWarrantyProgramBYOD].isVisible = false;
          formFields[subscriberExtendedWarrantyProgramBYOD].value = '';
          orderData[subscriberExtendedWarrantyProgramBYOD] = '';
          formFields[fieldSubscriberExtendedWarrantyProgram].isVisible = false;
          formFields[fieldSubscriberExtendedWarrantyProgram].value = '';
          orderData[fieldSubscriberExtendedWarrantyProgram] = '';
          formFields[fieldSubscriberDetailsDeviceCare].isRequired = false;
        formFields[fieldSubscriberDetailsDeviceCare].isVisible = false;
        formFields[fieldSubscriberDetailsDeviceCare].value = [];
        orderData[fieldSubscriberDetailsDeviceCare] = [];
        clearFieldErrors(fieldSubscriberDetailsDeviceCare);
          return null;
        }
      }

      if (
        formFields &&
        formFields[fieldSubscriberExtendedWarrantyProgram]
      ) {
        formFields[fieldSubscriberExtendedWarrantyProgram].isVisible = true;
      }
      // Making Device Care selection mandatory
      if (
        fieldName === fieldSubscriberExtendedWarrantyProgram &&
        formFields &&
        (formFields[fieldSubscriberExtendedWarrantyProgram].value === 'Yes' ||
          formFields[fieldSubscriberExtendedWarrantyProgram].value === 'Oui')
      ) {
        formFields[fieldSubscriberDetailsDeviceCare].isRequired = true;
      } else if (
        fieldName === fieldSubscriberExtendedWarrantyProgram &&
        formFields &&
        (formFields[fieldSubscriberExtendedWarrantyProgram].value === 'No' ||
          formFields[fieldSubscriberExtendedWarrantyProgram].value === 'Non')
      ) {
        formFields[fieldSubscriberDetailsDeviceCare].isRequired = false;
        formFields[fieldSubscriberDetailsDeviceCare].isVisible = false;
        formFields[fieldSubscriberDetailsDeviceCare].value = [];
        orderData[fieldSubscriberDetailsDeviceCare] = [];
        clearFieldErrors(fieldSubscriberDetailsDeviceCare);
      } else if (formFields && formFields[fieldSubscriberDetailsDeviceCare]) {
        formFields[fieldSubscriberDetailsDeviceCare].isVisible = true;
      }

      // Filtering options if cpo = Yes
      let copiedDeviceCareOptions;
      if (
        fieldName === fieldSubscriberDetailsDeviceCare &&
        formFields &&
        formFields[fieldSubscriberDetailsDeviceCare].options &&
        (formFields[fieldSubscriberDetailsIsCpoDevice].value === 'Yes' ||
          formFields[fieldSubscriberDetailsIsCpoDevice].value === 'Oui' ||
          orderData.provinceWLS === 'quebec' ||
            orderData.provinceWLS === 'Quebec')
      ) {
        copiedDeviceCareOptions =
          formFields[fieldSubscriberDetailsDeviceCare].options;

        fields.options = getUpdatedOptions(
          formFields[fieldSubscriberDetailsDeviceCare].options,
          [
            appleCareTier5,
            appleCareTier4,
            appleCarePlus12,
            appleCarePlus9,
            appleCareTier4A
          ]
        );
        formFields[fieldSubscriberDetailsDeviceCare].options = fields.options;
      } else if (
        fieldName === fieldSubscriberDetailsDeviceCare &&
        formFields &&
        formFields[fieldSubscriberDetailsDeviceCare].options &&
        formFields[fieldSubscriberDetailsIsCpoDevice] &&
        (formFields[fieldSubscriberDetailsIsCpoDevice].value === 'No' ||
          formFields[fieldSubscriberDetailsIsCpoDevice].value === 'Non')
      ) {
        formFields[
          fieldSubscriberDetailsDeviceCare
        ].options = copyDeviceCareOptions;
        fields.options = getUpdatedOptions(
          formFields[fieldSubscriberDetailsDeviceCare].options,
          []
        );
        formFields[fieldSubscriberDetailsDeviceCare].options = fields.options;
      }
      // Hide Esim related questions from ticket sof-2402 if form is smbonline
      if (isSMBOnline) {
        if (formFields && fieldName === fieldDeviceTypeTablet) {
          formFields[fieldDeviceTypeTablet].isRequired = false;
          clearFieldErrors(fieldDeviceTypeTablet);
          return null;
        }
        if (formFields && fieldName === fieldsimTypeTablet) {
          clearFieldErrors(fieldsimTypeTablet);
          return null;
        }
        if (formFields && fieldName === fieldEidTablet) {
          clearFieldErrors(fieldEidTablet);
          return null;
        }
        if (formFields && fieldName === fieldImeiTablet) {
          clearFieldErrors(fieldImeiTablet);
          return null;
        }
      }
      // Hide Esim related questions from ticket sof-2190 if channel is 7x
      if (isChannelSevenX) {
        if (formFields && fieldName === fieldDeviceType) {
          formFields[fieldDeviceType].isRequired = false;
          clearFieldErrors(fieldDeviceType);
          return null;
        }
        if (formFields && fieldName === fieldsimType2Year) {
          formFields[fieldsimType2Year].isRequired = false;
          clearFieldErrors(fieldsimType2Year);
          return null;
        }
        if (formFields && fieldName === fieldsimTypeByod) {
          clearFieldErrors(fieldsimTypeByod);

          return null;
        }
        if (formFields && fieldName === fieldEid) {
          clearFieldErrors(fieldEid);
          return null;
        }
        if (formFields && fieldName === fieldImei) {
          clearFieldErrors(fieldImei);
          return null;
        }
      }
        if (formFields && formFields[fieldSubscriberDetailsTier] && formFields[fieldSubscriberDetailsTier].options && fieldName === fieldSubscriberDetailsTier && renewal.includes(orderData.installationTypeWLS) &&
            (formFields.subscriberDetailsContractTerm.value === contractTerm2Year || formFields.subscriberDetailsContractTerm.value === contractTerm2YearFr)) {
            fields.options = getUpdatedOptions(
                formFields[fieldSubscriberDetailsTier].options,
                subscriberTierStandardZeroUpfront
            ); 
        }
        else if(formFields && formFields[fieldSubscriberDetailsTier] && formFields[fieldSubscriberDetailsTier].options && fieldName === fieldSubscriberDetailsTier)
        {
            fields.options = formFields[fieldSubscriberDetailsTier].options;
        }

            const rawValueSubscriberDetailsDevices = getFieldValue(
              fieldSubscriberDetailsDevices,
              formFields
            );

            let valueSubscriberDetailsDevices = {};
            if (rawValueSubscriberDetailsDevices) {
              try {
                valueSubscriberDetailsDevices =
                  typeof rawValueSubscriberDetailsDevices === 'string'
                    ? JSON.parse(rawValueSubscriberDetailsDevices)
                    : rawValueSubscriberDetailsDevices;
              } catch {
                valueSubscriberDetailsDevices = {};
              }
            }
            const SIM_FIELDS = [
              fieldsimType2Year,
              fieldsimType3Year,
              subscriberDetailsIsSimRequired,
              subscriberDetailsIsSimRequiredDevicesAccessories
            ];

            const isSimFieldUpdate = (formFields, fieldName) =>
              formFields &&
              SIM_FIELDS.some(field => formFields[field]) &&
              SIM_FIELDS.includes(fieldName);

            const isRenewalInstall = type => renewal.includes(type);

            const isIPhone = device => {
                if (!device || !device.device_name) return false;
                return device.device_name.toLowerCase().includes('iphone');
            };
            
            const resetSimFields = formFields => {
              formFields.subscriberDetailsIsSimRequiredDevicesAccessories.value = undefined;
              formFields.subscriberDetailsIsSimRequired.value = undefined;
              formFields.simType2Year.value = undefined;
              formFields.simType3Year.value = undefined;

              formFields.subscriberDetailsIsSimRequiredDevicesAccessories.isRequired = false;
              formFields.subscriberDetailsIsSimRequired.isRequired = false;
              formFields.simType2Year.isRequired = false;
              formFields.simType3Year.isRequired = false;
            };
            

            if (
              isSimFieldUpdate(formFields, fieldName) &&
              isIPhone(valueSubscriberDetailsDevices)
            ) {
              resetSimFields(formFields);
              return null;
            }

            if (
              isSimFieldUpdate(formFields, fieldName) &&
              isRenewalInstall(orderData.installationTypeWLS)
            ) {
              return null;
            }

            const isTargetDevice =
              formFields &&
              formFields[fieldSubscriberDetailsDevices] &&
              fieldName === fieldSubscriberDetailsDevices &&
              valueSubscriberDetailsDevices &&
              valueSubscriberDetailsDevices.device_name &&
              appleIphoneSixteenDevicesWLS.includes(
                valueSubscriberDetailsDevices.device_name.trim()
              );

            const isRenewalInstallType =
              formFields &&
              formFields[fieldSubscriberDetailsDevices] &&
              fieldName === fieldSubscriberDetailsDevices &&
              renewal.includes(orderData.installationTypeWLS);

            if (isTargetDevice || isRenewalInstallType) {
              resetSimFields(formFields);
            }

            if (
              formFields &&
              formFields[fieldsimType3Year] &&
              fieldName === fieldsimType3Year &&
              valueSubscriberDetailsDevices &&
              valueSubscriberDetailsDevices.device_name &&
              !/\bApple\b/i.test(
                valueSubscriberDetailsDevices.device_name.trim()
              )
            ) {
              fields.label =
                'Sim Type (For all devices updated to esim ONLY, no physical sim will be shipped, if selected)';
            }

            if (!isChannelSevenX) {
              // let isAppleDeviceSelected;
              // // Hiding Sim Type Field if no apple device is selected under 2 year term
              // if (
              //   formFields &&
              //   formFields[fieldSubscriberDetailsDevices] &&
              //   formFields[fieldSubscriberDetailsDevices].value
              // ) {
              //   const { device_name } =
              //     typeof formFields[fieldSubscriberDetailsDevices].value !==
              //     'object'
              //       ? JSON.parse(
              //           formFields[fieldSubscriberDetailsDevices].value
              //         )
              //       : formFields[fieldSubscriberDetailsDevices].value;
              //   // If Selected Device is an object value but in a string, then convert it to an Object otherwise keep it the original value
              //   const lowerDeviceName = device_name.toLocaleLowerCase();
              //   if (lowerDeviceName.includes('apple')) {
              //     isAppleDeviceSelected = true;
              //   }
              // }
              // if (fieldName === fieldsimType2Year && !isAppleDeviceSelected) {
              //   formFields[fieldsimType2Year].isVisible = false;
              //   formFields[fieldsimType2Year].isRequired = false;
              //   clearFieldErrors(fieldsimType2Year);

              //   return null;
              // } else if (formFields && formFields[fieldsimType2Year]) {
              //   formFields[fieldsimType2Year].isVisible = true;
              // }
              if (formFields && formFields[fieldsimType2Year] &&
                fieldName === fieldsimType2Year &&
                renewal.includes(orderData.installationTypeWLS) &&
                (formFields[subscriberDetailsIsSimRequired].value === 'No' ||
                  formFields[subscriberDetailsIsSimRequired].value === undefined)
              ) {
                formFields[fieldsimType2Year].isRequired = false;
                formFields[fieldsimType2Year].isVisible = false;
                const updatedErrors = formErrors;
                delete updatedErrors[fieldName];
                setFormErrors(updatedErrors);
              //   clearFieldErrors(fieldsimType2Year)
                return null;
              } else if(formFields && formFields[fieldsimType2Year] &&
                renewal.includes(orderData.installationTypeWLS) &&
                (formFields[subscriberDetailsIsSimRequired].value === 'Yes')){
                formFields[fieldsimType2Year].isRequired = true;
                formFields[fieldsimType2Year].isVisible = true;
              }
              if (
                formFields &&
                formFields[fieldsimType3Year] &&
                fieldName === fieldsimType3Year &&
                renewal.includes(orderData.installationTypeWLS) &&
                (formFields[subscriberDetailsIsSimRequired].value === 'No' ||
                  formFields[subscriberDetailsIsSimRequired].value === undefined)
              ) {
                formFields[fieldsimType3Year].isRequired = false;
                formFields[fieldsimType3Year].isVisible = false;
                clearFieldErrors(fieldsimType3Year)
                return null;
              } else if(formFields && formFields[fieldsimType3Year]  &&
              renewal.includes(orderData.installationTypeWLS) &&
              (formFields[subscriberDetailsIsSimRequired].value === 'Yes')) {
                formFields[fieldsimType3Year].isRequired = true;
                formFields[fieldsimType3Year].isVisible = true;
              }
              if (fieldName === fieldImei && isSMBOnline) {
                formFields[fieldImei].isRequired = false;
                clearFieldErrors(fieldImei);
              } else if (fieldName === fieldImei) {
                formFields[fieldImei].isRequired = true;
              }

              // Handle conditional visibility for device condition fields based on tradeInImei
              const deviceConditionFields = [
                'devicePowerOn',
                'deviceActivationLock',
                'devicePhysicalCondition',
                'deviceDisplayIssues',
                'deviceComponentsFunctionality'
              ];

              if (deviceConditionFields.includes(fieldName)) {
                const tradeInImeiValue = formFields.tradeInImei && formFields.tradeInImei.value;
                
                if (!tradeInImeiValue || tradeInImeiValue.trim() === '') {
                  // Hide fields when tradeInImei is empty
                  formFields[fieldName].isVisible = false;
                  formFields[fieldName].isRequired = false;
                  const updatedErrors = formErrors;
                  delete updatedErrors[fieldName];
                  setFormErrors(updatedErrors);
                  return null;
                } else {
                  // Show fields when tradeInImei has a value
                  formFields[fieldName].isVisible = true;
                  formFields[fieldName].isRequired = true;
                }
              }
              if (
                fieldName === fieldSubscriberDetailsEsimSubmission &&
                formFields &&
                formFields[fieldsimTypeByod].value === valueEsim
              ) {
                formFields[
                  fieldSubscriberDetailsEsimSubmission
                ].isRequired = false;
                formFields[
                  fieldSubscriberDetailsEsimSubmission
                ].isVisible = false;
                const errorsUpdated = formErrors;
                delete errorsUpdated[fieldSubscriberDetailsEsimSubmission];
                setFormErrors(errorsUpdated);
                return null;
              } else if (
                formFields &&
                formFields[fieldsimTypeByod] &&
                formFields[fieldsimTypeByod].value !== valueEsim
              ) {
                formFields[
                  fieldSubscriberDetailsEsimSubmission
                ].isVisible = true;
              }
            }

            if (fieldName === fieldsimTypeByod || fieldName === fieldsimTypeTablet) {
              const valueDeviceType = getFieldValue(
                fieldDeviceType,
                formFields
              );
              const valueDeviceTypeTablet = getFieldValue(
                fieldDeviceTypeTablet,
                formFields
              );
              if (
                valueDeviceType === 'Apple Device' ||
                valueDeviceTypeTablet === 'Apple iPad'
              ) {
                fields.label = 'Sim Type';
              } else {
                fields.label =
                  'Sim Type (For all devices updated to esim ONLY, no physical sim will be shipped, if selected)';
              }
            }

            if (
              getFieldValue(fieldSubscriberDetailsDevicePlan, formFields) ===
                `Smartphones` &&
              fieldName === fieldsimType2Year
            ) {
              let isAppleDeviceSelected;
              // Update Sim Type Label Field if no apple device is selected under 2 year term
              if (
                formFields &&
                formFields[fieldSubscriberDetailsDevices] &&
                formFields[fieldSubscriberDetailsDevices].value
              ) {
                const { device_name } =
                  typeof formFields[fieldSubscriberDetailsDevices].value !==
                  'object'
                    ? JSON.parse(
                        formFields[fieldSubscriberDetailsDevices].value
                      )
                    : formFields[fieldSubscriberDetailsDevices].value;
                // If Selected Device is an object value but in a string, then convert it to an Object otherwise keep it the original value
                const lowerDeviceName = device_name.toLocaleLowerCase();
                if (lowerDeviceName.includes('apple')) {
                  isAppleDeviceSelected = true;
                } else {
                  isAppleDeviceSelected = false;
                }
              }

              if (isAppleDeviceSelected === true) {
                fields.label = 'Sim Type';
              } else if (isAppleDeviceSelected === false) {
                fields.label =
                  'Sim Type (For all devices updated to esim ONLY, no physical sim will be shipped, if selected)';
              } else {
                return null;
              }
            }

      if (
        fieldName === subscriberDetailsAccessoryFinanced &&
        !isAccessoriesOnly &&
        !isSMBOnline
      ) {
        return null;
      }

      if (
        fieldName === subscriberDetailsAccessoryFinanced &&
        (isAccessoriesOnly || isSMBOnline) &&
        formFields[subscriberDetailsAccessoryFinanced] &&
        formFields[subscriberDetailsAccessoryFinanced].checked
      ) {
        formFields[fieldSubscriberDetailsSpecialInstructions].isRequired = true;
      } else if (
        fieldName === subscriberDetailsAccessoryFinanced &&
        formFields[fieldSubscriberDetailsSpecialInstructions]
      ) {
        formFields[
          fieldSubscriberDetailsSpecialInstructions
        ].isRequired = false;
        const errorsUpdated = formErrors;
        delete errorsUpdated[fieldSubscriberDetailsSpecialInstructions];
        setFormErrors(errorsUpdated);
      }
      /*
       * Check to display subscriberDetailsIsSimRequired only for Renewal
       */
      if (
        fieldName === subscriberDetailsIsSimRequired &&
        !renewal.includes(orderData.installationTypeWLS) &&
        formFields.subscriberDetailsIsSimRequired
      ) {
        formFields.subscriberDetailsIsSimRequired.isVisible = false;
        return null;
      }
      /*
       * Check to display subscriberDetailsIsSimRequiredDevicesAccessories only for Accessories
       * only and devices only flows
       */
      if (
        fieldName === subscriberDetailsIsSimRequiredDevicesAccessories &&
        formFields.subscriberDetailsIsSimRequiredDevicesAccessories
      ) {
        if (!isAccessoriesOnly && !isDevicesOnly) {
          formFields.subscriberDetailsIsSimRequiredDevicesAccessories.isVisible = false;
          return null;
        } else {
          formFields.subscriberDetailsIsSimRequiredDevicesAccessories.isVisible = true;
        }
      }
      if (
        formFields.subscriberDetailsIsSimRequiredDevicesAccessories &&
        !simRequiredReasonOnlyVariations.includes(
          formFields.subscriberDetailsIsSimRequiredDevicesAccessories.value
        )
      ) {
        formFields.subscriberDetailsSimRequiredReason.value = '';
      }

      /**
       * Filter out Device Plans based on the contract term
       */
      if (fieldName === fieldSubscriberDetailsDevicePlan && formFields && formFields[fieldName].options) {
        const valueContractTerm = getFieldValue(
          fieldSubscriberDetailsContractTerm,
          formFields
        );

        selectOptions = getCategories(
          formFields[fieldName].options,
          valueContractTerm,
          {
            ...translations,
            localTranslations: {
              valueThreeYear,
              valueBasicEasyPayment,
              valueBusinessSharePro,
              valueEasyPayment,
              valueTablet,
              valueWatch,
              valueMobileHighSpeedSmartHub
            }
          }
        );
      }
      /**
       * render Three Year Form Fields logic
       */
      const devicesVisibilityThreeYears = isDevicesFieldThreeYearsVisible(
        formFields,
        locale
      );
      if (!devicesVisibilityThreeYears) {
        if (
          fieldName === fieldSubscriberDetailsDevices &&
          formFields[fieldSubscriberDetailsDevices]
        ) {
          formFields[fieldSubscriberDetailsDevices].value = '';
          return null;
        }
      }
      /**
       * Hiding Ported In for Renewal Installation Type
       */
      if (
        fieldName === subscriberDetailsWillPhoneNumberBePortedIn &&
        renewal.includes(orderData.installationTypeWLS) &&
        formFields.subscriberDetailsWillPhoneNumberBePortedIn
      ) {
        formFields.subscriberDetailsWillPhoneNumberBePortedIn.isVisible = false;
        return null;
      }
      /**
       * Hiding devices fields form Unlimited for Business
       * unitl all the necessary fields are selected to pull deivces
       */
      if (
        fieldName === fieldSubscriberDetailsDevices &&
        fieldValue !== undefined &&
        formFields[fieldSubscriberDetailsDevices] &&
        formFields[fieldSubscriberDetailsDevices].options === undefined
      ) {
        getDevicesFromAPI(
          getFieldValue(fieldSubscriberDetailsDevicePlan, formFields),
          getFieldValue(fieldSubscriberDetailsIsCpoDevice, formFields),
          getFieldValue(fieldSubscriberDetailsTier, formFields),
          localStorage.getItem('provinceWLS') || '',
          getFieldValue(fieldSubscriberDetailsCpoCategory, formFields),
          getFieldValue(fieldSubscriberDetailsContractTerm, formFields),
          getFieldValue(fieldSubscriberDetailsBibProgram, formFields)
        ).then(devices => {
          if (devices && devices.length) {
            setIsLoading({
              status: false,
              message: ''
            });
            formFields[fieldSubscriberDetailsDevices].options = devices;
          }
        });
      }
      if (
        fieldName === fieldSubscriberDetailsDevices &&
        getFieldValue(fieldSubscriberDetailsDevicePlan, formFields) ===
          valueUnlimitedForBusiness &&
        getFieldValue(fieldSubscriberDetailsContractTerm, formFields) !==
          valueOwnersAdvantagePlan
      ) {
        const valueIsCpoDevice = getFieldValue(
          fieldSubscriberDetailsIsCpoDevice,
          formFields
        );
        const valueCpoCategory = getFieldValue(
          fieldSubscriberDetailsCpoCategory,
          formFields
        );
        if (!valueIsCpoDevice && !valueCpoCategory) return null;
      }
      if (
        fieldName === fieldSubscriberDetailsIsCpoDevice &&
        getFieldValue(fieldSubscriberDetailsContractTerm, formFields) ===
          valueOwnersAdvantagePlan
      ) {
        formFields[fieldSubscriberDetailsIsCpoDevice].isVisible = false;
        return null;
      }
      /**
       * Hiding Color fields if no options are present
       */
      if (
        fieldName === fieldSubscriberDetailsColor &&
        formFields[fieldSubscriberDetailsColor]
      ) {
        if (
          formFields[fieldSubscriberDetailsColor].options === undefined ||
          (formFields[fieldSubscriberDetailsColor].options !== undefined &&
            formFields[fieldSubscriberDetailsColor].options.length === 0)
        ) {
          formFields[fieldSubscriberDetailsColor].isVisible = false;
          return null;
        }
        formFields[fieldSubscriberDetailsColor].isVisible = true;
      }
      /**
       * Hiding HardwareCredit fields if device doesn't have a harcwarecredit
       */
      if (
        fieldName === fieldSubscriberDetailsHardwareCredit &&
        !getFieldValue(fieldSubscriberDetailsHardwareCredit, formFields)
      )
        return null;

      /*
       * Check to display subscriberDetailsPromotions only for 7X channel
       */
      if (
        formFields[fieldSubscriberDetailsPromotions] &&
        fieldName === fieldSubscriberDetailsPromotions &&
        !isChannelSevenX
      ) {
        formFields[fieldSubscriberDetailsPromotions].isVisible = false;
        return null;
      }
      if (formFields)
        if (
          fieldName === fieldSubscriberDetailsContractTerm &&
          formFields[fieldSubscriberDetailsContractTerm]
        ) {
          // Contract Term Conditions
          if (renewal.includes(orderData.installationTypeWLS)) {
            fields.options = getUpdatedOptions(
              formFields[fieldSubscriberDetailsContractTerm].options,
              contractTermBYOD
            );
            formFields[fieldSubscriberDetailsContractTerm].options =
              fields.options;
          }
          
          if (!renewal.includes(orderData.installationTypeWLS)) {
            fields.options = getUpdatedOptions(
              formFields[fieldSubscriberDetailsContractTerm].options,
              contractTerm3Year
            );
            formFields[fieldSubscriberDetailsContractTerm].options =
              fields.options;
          }
          if (
            !(
              renewal.includes(orderData.installationTypeWLS) ||
              newWirelessActivation.includes(orderData.installationTypeWLS)
            )
          ) {
            fields.options = getUpdatedOptions(
              formFields[fieldSubscriberDetailsContractTerm].options,
              valueDevicePurchaseMtm
            );
            formFields[fieldSubscriberDetailsContractTerm].options =
              fields.options;
          }
          if (
            renewal.includes(orderData.installationTypeWLS) &&
            orderData.accountType !== fieldBusinessRegularMedium[0] &&
            orderData.accountType !== fieldBusinessRegularMedium[1]
          ) {
            fields.options = getUpdatedOptions(
              formFields[fieldSubscriberDetailsContractTerm].options,
              contractTerm3Year
            );
            formFields[fieldSubscriberDetailsContractTerm].options =
              fields.options;
          }
          // SOF-1642
          // if (orderData.accountType === fieldBusinessRegularMedium) {
          //   fields.options = getUpdatedOptions(
          //     formFields[fieldSubscriberDetailsContractTerm].options,
          //     [valueByod]
          //   );
          //   formFields[fieldSubscriberDetailsContractTerm].options =
          //     fields.options;

          //   fields.options = getUpdatedOptions(
          //     formFields[fieldSubscriberDetailsContractTerm].options,
          //     [contractTerm2Year]
          //   );
          //   formFields[fieldSubscriberDetailsContractTerm].options =
          //     fields.options;

          //   fields.options = getUpdatedOptions(
          //     formFields[fieldSubscriberDetailsContractTerm].options,
          //     [valueOwnersAdvantagePlan]
          //   );
          //   formFields[fieldSubscriberDetailsContractTerm].options =
          //     fields.options;

          //   fields.options = getUpdatedOptions(
          //     formFields[fieldSubscriberDetailsContractTerm].options,
          //     [valueDevicePurchaseMtm]
          //   );
          //   formFields[fieldSubscriberDetailsContractTerm].options =
          //     fields.options;
          // }
        }

      const excludedFieldsDevicesOnlyFlow = [
        subscriberDetailsWillPhoneNumberBePortedIn,
        ...sectionSpecialOffersVariations,
        fieldSubscriberDetailsContractTerm
      ];

      const excludedFieldsAccessoriesOnlyFlow = [
        subscriberDetailsWillPhoneNumberBePortedIn,
        ...sectionSpecialOffersVariations,
        fieldSubscriberDetailsContractTerm
      ];

      const haveAllDeviceEnrolmentDependentFieldsRendered =
        formFields[subscriberDetailsContractTerm] &&
        formFields[fieldSubscriberDetailsDevicePlan];

      if (
        haveAllDeviceEnrolmentDependentFieldsRendered &&
        fieldName === subscriberDetailsDeviceEnrolmentProgram &&
        !(
          isDevicesOnly ||
          (formFields[subscriberDetailsContractTerm].value === valueTwoYear &&
            formFields[fieldSubscriberDetailsDevicePlan].value ===
              valueUnlimitedForBusiness) ||
          (formFields[subscriberDetailsContractTerm].value ===
            valueOwnersAdvantagePlan &&
            formFields[fieldSubscriberDetailsDevicePlan].value ===
              valueUnlimitedForBusiness) ||
          (formFields[subscriberDetailsContractTerm].value === valueTwoYear &&
            formFields[fieldSubscriberDetailsDevicePlan].value ===
              valueTablet) ||
          (renewal.includes(orderData.installationTypeWLS) &&
            valueThreeYearVariations.includes(
              formFields[subscriberDetailsContractTerm].value
            ))
        )
      ) {
        formFields[subscriberDetailsDeviceEnrolmentProgram].value = undefined;
        formFields[subscriberDetailsDeviceEnrolmentProgram].isRequired = false;
        return null;
      }
      if (
        orderData.orderNotEligibleforMssReason &&
        (orderData.orderNotEligibleforMssReason.includes(DevicesOnlyEnglish) ||
          orderData.orderNotEligibleforMssReason.includes(DevicesOnlyFrench))
      ) {
        if (excludedFieldsDevicesOnlyFlow.includes(fields.name)) {
          if (formFields[fields.name]) {
            formFields[fields.name].isRequired = false;
            formFields[fields.name].isVisible = false;
            return null;
          }
        }
      }

      if (isAccessoriesOnly) {
        if (excludedFieldsAccessoriesOnlyFlow.includes(fields.name)) {
          if (formFields[fields.name]) {
            formFields[fields.name].isRequired = false;
            formFields[fields.name].isVisible = false;
            return null;
          }
        }
      }

      if (
        !(
          formStepFields &&
          orderData.orderNotEligibleforMssReason &&
          (orderData.orderNotEligibleforMssReason.includes(
            DevicesOnlyEnglish
          ) ||
            orderData.orderNotEligibleforMssReason.includes(
              DevicesOnlyFrench
            ) ||
            orderData.orderNotEligibleforMssReason.includes(
              AccessoriesOnlyEnglish
            ) ||
            orderData.orderNotEligibleforMssReason.includes(
              AccessoriesOnlyFrench
            ))
        )
      ) {
        if (
          fieldName === fieldSubscriberDetailsExistingPhoneNumber &&
          formFields[fieldSubscriberDetailsExistingPhoneNumber]
        ) {
          formFields[
            fieldSubscriberDetailsExistingPhoneNumber
          ].isRequired = false;
          formFields[
            fieldSubscriberDetailsExistingPhoneNumber
          ].isVisible = false;
          return null;
        }
      }

      if (id === 'formFieldsGroup') {
        if (isDevicesOnly) {
          if (excludedFieldsDevicesOnlyFlow.includes(fields.title)) return null;
        }
        if (isAccessoriesOnly) {
          if (excludedFieldsAccessoriesOnlyFlow.includes(fields.title))
            return null;
        }
        const groupIsVisible = fields.fields.find(item => {
          const { fields: itemFields } = item;

          if (!formFields[itemFields.name]) return null;
          const { value, isVisible } = formFields[itemFields.name];
          return (
            (value && isVisible) ||
            isRelatedFieldExisted(
              itemFields,
              formFields,
              orderData,
              formTouched
            )
          );
        });

        if (typeof groupIsVisible !== 'undefined') {
          result = (
            <GroupWrapper key={key}>
              {title && <GroupTitle>{title}</GroupTitle>}
              {renderFormFields(fields.fields)}
            </GroupWrapper>
          );
        }
      } else {
        let ref;
        let isDisabled;
        if (formFields[fieldName]) {
          ({ ref, isDisabled } = formFields[fieldName]);
        }
        if (
          ['Radio', 'Select', 'Checkbox', 'MultiCheckbox'].includes(
            fields.type
          ) &&
          !fields.options
        ) {
          if (formFields[fieldName]) {
            selectOptions = formFields[fieldName].options;
          }
        }
        const fieldData = {
          ...fields,
          options: selectOptions || fields.options,
          ref,
          formFields,
          name: fieldName,
          value: fieldValue,
          disabled: isDisabled,
          sysId,
          onChange: (e, refV) => {
            onFieldChange(e.target, refV, true, {
              childAccessories: selectedAccessories,
              childFeatures: selectedFeatures,
              childDeviceCare: selectedDeviceCare,
              childDeviceCareBYOD: selectedDeviceCareBYOD
            });
          },
          onBlur: () => {}
        };

        if (fieldName === subscriberDetailsAccessoryFinanced) {
          if (isAccessoriesOnly) {
            fieldData.label =
              'Accessory Financing (For SMB Online orders ONLY. Leave detailed comments in special instructions of the accessory financing order)';
          } else if (isSMBOnline) {
            fieldData.label =
              'Accessory Financing (Leave detailed comments in special instructions of the accessory financing order)';
          }
        }

        if (fields.type === 'Checkbox') {
          fieldData.checked = fieldChecked;
          fieldData.value = fieldChecked;
        }
        if (fieldName === fieldSubscriberDetailsPromotions) {
          result = (
            <>
              <FormField
                key={key}
                data={fieldData}
                error={error && error.text}
              />
              <Promotions
                promotions={selectedPromotions}
                setPromotions={setSelectedPromotions}
              />
            </>
          );
        } else if (fieldName === fieldSubscriberDetailsSpecialInstructions) {
          result = (
            <>
              {!isChannelSevenX && (
                <Accessory
                  selectedAccessories={selectedAccessories}
                  setSelectedAccessories={setSelectedAccessories}
                />
              )}

              {!isAccessoriesOnly && (
                <Features
                  formFields={formFields}
                  selectedFeatures={selectedFeatures}
                  setSelectedFeatures={setSelectedFeatures}
                  showOnlyCategories={showOnlyCategories} // [] means no restriction
                  customFeatures={additionalFeaturesVisible}
                />
              )}
              {!isDevicesOnly && (
                <FormField
                  key={key}
                  data={fieldData}
                  error={error && error.text}
                />
              )}
            </>
          );
        }
        // Adding error through code because device credit field is optional in contentful
        else if (fieldName === fieldSubscriberDetailsDeviceCredit) {
          result = (
            <FormField
              key={key}
              data={fieldData}
              error={deviceCreditError.length > 0 && deviceCreditError}
            />
          );
        } else {
          result = (
            <FormField key={key} data={fieldData} error={error && error.text} />
          );
        }
      }
      return result;
    });

  useEffect(() => {
    // logic to copy already filled subscriber data into a new subscriber
    if (isCopyFromSubscriber && copyFromSubscriber) {
      const tempFormFields = formFields;
      setSelectedFeatures(_.get(copyFromSubscriber, 'features', []));
      setSelectedAccessories(_.get(copyFromSubscriber, 'accessories', []));

      const childFeatures = _.get(copyFromSubscriber, 'features', []);
      const childAccessories = _.get(copyFromSubscriber, 'accessories', []);
      const formFieldsToExclude = [
        subscriberDetailsFirstName,
        subscriberDetailsLastName,
        fieldSubscriberDetailsExistingPhoneNumber,
        subscriberDetailsWillPhoneNumberBePortedIn,
        subscriberDetailsPhoneNumber,
        subscriberDetailsServiceProvider,
        subscriberDetailsAccountNumber,
        subscriberDetailsPortInCredit,
        subscriberDetailsLocalCity,
        fieldSubscriberDetailsValidationCode,
        subscriberDetailsPhoneNumberRenewal,
        fieldSubscriberDetailsSpecialInstructions
      ];
      Object.keys(tempFormFields).forEach(field => {
        if (
          _.has(copyFromSubscriber, field) &&
          !formFieldsToExclude.includes(field)
        ) {
          onFieldChange(
            {
              name: field,
              value: copyFromSubscriber[field]
            },
            null,
            false,
            {
              childAccessories,
              childFeatures
            }
          );
        }
      });
      setTotal(_.get(copyFromSubscriber, 'total', {}));
      setFormFields({ ...tempFormFields });
      setIsCopyFromSubscriber(false);
    }
  });
  useEffect(() => {
    if (
      formStepFields &&
      orderData.orderNotEligibleforMssReason &&
      (orderData.orderNotEligibleforMssReason.includes(DevicesOnlyEnglish) ||
        orderData.orderNotEligibleforMssReason.includes(DevicesOnlyFrench))
    ) {
      setAdditionalFeaturesVisible(false);
      setIsDevicesOnly(true);
      setShowOnlyCategories([
        ...showOnlyCategories
        // ...valueDeviceCareVariation
      ]);
      setIsLoading({ status: true, message: 'Fetching devices...' });
      getDevicesFromAPI(
        devicePlanCategorySmartphones,
        true,
        'Standard-Zero Upfront',
        // Read from orderData, not localStorage — this effect and the sibling one that writes
        // provinceWLS to localStorage (index.js) both run on mount, and React commits child
        // effects (this component) before parent effects (index.js), so localStorage was still
        // empty here on a fresh session, causing an empty province to be sent to the devices API.
        orderData.provinceWLS || '',
        '',
        contractTerm2Year,
        false,
        true
      ).then(devices => {
        if (devices && devices.length) {
          const updatedDevices = devices
            .filter(
              item =>
                !item.fields.label.includes(' - Renewals') &&
                !item.fields.label.includes(' - Renewal')
            )
            .map(item => {
              return {
                ...item,
                fields: {
                  ...item.fields,
                  label: item.fields.label.replace(
                    / - Activations| - Activation/g,
                    ''
                  ),
                  value: item.fields.value.replace(
                    / - Activations| - Activation/g,
                    ''
                  )
                }
              };
            });
          const tempFormFields = formFields;
          tempFormFields[
            fieldSubscriberDetailsDevices
          ].options = updatedDevices;
          tempFormFields[fieldSubscriberDetailsDevices].value = '';
          setFormFields({ ...tempFormFields });
        }
        // Always clear the loading state, even when devices comes back empty/undefined —
        // previously this only happened inside the truthy-length branch above, so an empty
        // catalog response left the "Fetching devices..." spinner stuck forever.
        setIsLoading({ status: false, message: '' });
      });
    } else if (
      formStepFields &&
      orderData.orderNotEligibleforMssReason &&
      (orderData.orderNotEligibleforMssReason.includes(
        AccessoriesOnlyEnglish
      ) ||
        orderData.orderNotEligibleforMssReason.includes(AccessoriesOnlyFrench))
    ) {
      setIsAccessoriesOnly(true);
    }
  }, []);

  useEffect(() => {
    if (editingSubscriber) {
      const editingSubscriberDetails = subscriberDetails.filter(
        subscriberDetail => subscriberDetail.id === editingSubscriber
      )[0];

      setEditingSubscriberNumber(
        _.get(editingSubscriberDetails, 'subscriberNumber', 0)
      );
      setSelectedFeatures(_.get(editingSubscriberDetails, 'features', []));
      setSelectedAccessories(
        _.get(editingSubscriberDetails, 'accessories', [])
      );
      setSelectedDeviceCare(_.get(editingSubscriberDetails, 'deviceCare', []));
      setSelectedDeviceCareBYOD(_.get(editingSubscriberDetails, 'deviceCareBYOD', []));
      const childFeatures = _.get(editingSubscriberDetails, 'features', []);
      const childAccessories = _.get(
        editingSubscriberDetails,
        'accessories',
        []
      );
      const childDeviceCare = _.get(editingSubscriberDetails, 'deviceCare', []);
      const childDeviceCareBYOD = _.get(editingSubscriberDetails,'deviceCareBYOD',[]);
      const dummyFormFields = { ...formFields };
      Object.keys(dummyFormFields).forEach(field => {
        if (_.has(editingSubscriberDetails, field)) {
          onFieldChange(
            {
              name: field,
              value: editingSubscriberDetails[field],
              checked:
                formFields[field] && formFields[field].type === 'Checkbox'
                  ? editingSubscriberDetails[field]
                  : undefined
            },
            null,
            false,
            {
              childAccessories,
              childFeatures,
              childDeviceCare,
              childDeviceCareBYOD
            }
          );
        }
      });
      setTotal(_.get(editingSubscriberDetails, 'total', {}));
    }
  }, [editingSubscriber]);

  return (
    <>
      <form onSubmit={onFormSubmit} name="wirelessOrderDetails">
        <FormFieldsWrapper>
          <div style={{ width: '100%' }}>{renderFormFields(formStepFields)}</div>
        </FormFieldsWrapper>
      </form>
      {isLoading.status && <WlsLoader message={isLoading.message} />}
      {/* Opening modal when extended warranty is selected NO*/}
      {
        <Modal
          heading={'Warning'}
          bodyText={modalData.text}
          confirmButtonText={acknowledgeButton}
          onConfirm={() => setModalData({ ...modalData, open: false })}
          onClose={() => setModalData({ ...modalData, open: false })}
          isOpen={modalData.open}
        />
      }
    </>
  );
};

Form.propTypes = {
  formStepFields: PropTypes.arrayOf(PropTypes.any).isRequired,
  formFields: PropTypes.arrayOf(PropTypes.any).isRequired,
  setFormFields: PropTypes.func.isRequired,
  orderData: PropTypes.arrayOf(PropTypes.any).isRequired,
  onFormSubmit: PropTypes.func.isRequired,
  setFormTouched: PropTypes.func.isRequired,
  formTouched: PropTypes.bool.isRequired,
  formErrors: PropTypes.arrayOf(PropTypes.any).isRequired,
  selectedFeatures: PropTypes.arrayOf(PropTypes.any).isRequired,
  setSelectedFeatures: PropTypes.func.isRequired,
  selectedDeviceCare: PropTypes.arrayOf(PropTypes.any).isRequired,
  setSelectedDeviceCare: PropTypes.func.isRequired,
  selectedAccessories: PropTypes.arrayOf(PropTypes.any).isRequired,
  setSelectedAccessories: PropTypes.func.isRequired,
  selectedPromotions: PropTypes.arrayOf(PropTypes.any).isRequired,
  setSelectedPromotions: PropTypes.func.isRequired,
  // totalSubscribers: PropTypes.number.isRequired,
  setTotal: PropTypes.arrayOf(PropTypes.any).isRequired,
  total: PropTypes.objectOf(PropTypes.any).isRequired,
  subscriberDetails: PropTypes.arrayOf(PropTypes.any).isRequired,
  editingSubscriber: PropTypes.string.isRequired,
  setEditingSubscriberNumber: PropTypes.func.isRequired,
  isCopyFromSubscriber: PropTypes.bool.isRequired,
  setIsCopyFromSubscriber: PropTypes.func.isRequired,
  copyFromSubscriber: PropTypes.objectOf(PropTypes.any).isRequired
};

export default Form;
